module.exports = __webpack_public_path__ + "img/launchpad-rocket-moonbeam.76e1e8fd.svg";